import { render, staticRenderFns } from "./MomoSuccess.vue?vue&type=template&id=2fa780cc&"
import script from "./MomoSuccess.vue?vue&type=script&lang=ts&"
export * from "./MomoSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports